import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { MessageService } from '../../services/message.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-form-servicios',
  templateUrl: './form-servicios.component.html',
  styleUrls: ['./form-servicios.component.css']
})
export class FormServiciosComponent implements OnInit {
  url: string = 'categories';
  loading: boolean = false;
  id: string = '';
  form!: FormGroup;

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.form = this.fb.group({
      name: ['', [Validators.required]],
      value: ['', [Validators.required, Validators.min(0)]],
      status: [true]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
  }

  onSubmit(): void {
    if (this.form.valid) {
      this.loading = true;
      if (this.id) {
        this.updateData();
      } else {
        this.createData();
      }
    } else {
      this.messageService.add('Por favor complete todos los campos requeridos', 'warning');
      Object.keys(this.form.controls).forEach(key => {
        const control = this.form.get(key);
        if (control?.invalid) {
          control.markAsTouched();
        }
      });
    }
  }

  private prepareFormData(): any {
    const formData = { ...this.form.value };
    
    // Asegurarse de que value sea un número
    formData.value = Number(formData.value);

    // El status ya es un booleano por ser un checkbox
    return formData;
  }

  createData(): void {
    const formData = this.prepareFormData();
    console.log('Enviando datos:', formData);

    this.dataService.postData(`${this.url}/add`, formData).subscribe({
      next: (response: any) => {
        console.log('Respuesta del servidor:', response);
        if (response && response.rst === true) {
          this.messageService.add('Servicio creado exitosamente', 'success');
          this.router.navigate(['/administracion/services']);
        } else {
          this.messageService.add(response?.msg || 'Error al crear el servicio', 'danger');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al crear:', error);
        this.messageService.add('Error al crear el servicio: ' + (error.error?.msg || error.message), 'danger');
        this.loading = false;
      }
    });
  }

  getData(): void {
    this.loading = true;
    this.dataService.getData(`${this.url}/get/${this.id}`).subscribe({
      next: (response: any) => {
        if (response && response.data) {
          this.form.patchValue({
            name: response.data.name,
            value: response.data.value,
            status: response.data.status
          });
        } else {
          this.messageService.add('No se encontró el servicio', 'warning');
          this.router.navigate(['/administracion/services']);
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al obtener datos:', error);
        this.messageService.add('Error al cargar los datos: ' + (error.error?.msg || error.message), 'danger');
        this.loading = false;
        this.router.navigate(['/administracion/services']);
      }
    });
  }

  updateData(): void {
    const formData = this.prepareFormData();
    console.log('Actualizando datos:', formData);

    this.dataService.putData(`${this.url}/update/${this.id}`, formData).subscribe({
      next: (response: any) => {
        console.log('Respuesta del servidor:', response);
        if (response && response.rst === true) {
          this.messageService.add('Servicio actualizado exitosamente', 'success');
          this.router.navigate(['/administracion/services']);
        } else {
          this.messageService.add(response?.msg || 'Error al actualizar el servicio', 'danger');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al actualizar:', error);
        this.messageService.add('Error al actualizar el servicio: ' + (error.error?.msg || error.message), 'danger');
        this.loading = false;
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/administracion/services']);
  }
}
